import React, { Fragment } from 'react';
import Loading from 'elements/Loading/Loading';

/* eslint-disable react/prop-types */
export const DefaultLoading = ({ dark, large, simple }) => (
  <Fragment>
    <Loading dark={dark} large={large} simple={simple}/>
  </Fragment>
);
/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Loadings/constants/loadingsLayouts.js